
import React from 'react';
import { Link } from 'react-router-dom';
import { TechniqueCard } from '@/components/TechniqueCard';
import { UserTechnique, Technique } from '@/types/technique';
import { usePermissions } from '@/contexts/unified-permissions';

interface TechniquesGridProps {
  techniques: UserTechnique[];
  techniquesWithVideos: Record<string, boolean>;
  onRemoveTechnique: (id: string, e: React.MouseEvent) => void;
  onEditTechnique: (e: React.MouseEvent, technique: Technique, notes: string) => void;
}

export const TechniquesGrid: React.FC<TechniquesGridProps> = ({
  techniques,
  techniquesWithVideos,
  onRemoveTechnique,
  onEditTechnique
}) => {
  const { user } = usePermissions();
  
  if (techniques.length === 0) {
    return null;
  }
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {techniques.map((userTechnique) => {
        if (!userTechnique.technique) return null;
        const technique = userTechnique.technique;
        const hasVideos = !!techniquesWithVideos[technique.id];
        const isUserCreated = technique.is_user_created && technique.created_by_user_id === user?.id;
        
        return (
          <Link to={`/techniques/${technique.slug}`} key={userTechnique.id}>
            <TechniqueCard
              id={technique.id}
              name={technique.name}
              description={technique.description}
              level={technique.difficulty}
              type={technique.technique_type}
              position={technique.position?.name || ''}
              imageUrl={technique.image_url || undefined}
              onSave={(e) => onRemoveTechnique(technique.id, e)}
              saved={true}
              hasNotes={!!userTechnique.notes && userTechnique.notes.length > 0}
              hasVideos={hasVideos}
              isEditable={isUserCreated}
              isUserCreated={isUserCreated}
              onEdit={isUserCreated ? 
                (e) => onEditTechnique(e, technique, userTechnique.notes || '') : 
                undefined}
            />
          </Link>
        );
      })}
    </div>
  );
};
